import * as Yup from 'yup';

export default function getPhoneNumberSchema(fieldName: string = 'Phone Number') {
  return Yup.string().trim().required(`${fieldName} is required`);
}
